


(function(algolia) {
  'use strict';
  var rangeSlider = algolia.externals.widgets.rangeSlider;
  var menu = algolia.externals.widgets.menu;
  var refinementList = algolia.externals.widgets.refinementList;

  var facetes_relation = {
    'named_tags.Make' : {
      'Buick':{ 'named_tags.Model' : ["Park Avenue","Regal","Riveria"] },
      'Cadillac': { 'named_tags.Model' :["CTS-V", "CTS"] },
      'Chevrolet': { 'named_tags.Model': ["Camaro", "Silverado", "Blazer", "Suburban", "Tahoe", "S-10", "Impala", "Cobalt", "Monte Carlo"] },
      'Chrysler': { 'named_tags.Model': ["300", "Aspen"] },
      'Dodge': { 'named_tags.Model': ["Challenger", "Charger", "Durango", "Ram", "Magnum"]} ,
      'Ford': {'named_tags.Model': ["F-150", "Mustang"]},
      'GMC': {'named_tags.Model': ["Yukon", "Sierra"]},
      'Jeep': {'named_tags.Model': ["Wrangler", "Cherokee", "Grand Cherokee", "Commander"]},
      'Ram': {'named_tags.Model': ["1500", "1500 Classic", "2500", "3500", "4000"]},
      'Nissan': {'named_tags.Model': ["M35", "Altima", "Maxima", "Murano", "Quest", "FX35", "G35", "Altima", "350Z", "I35", "Pathfinder", "QX4", "Frontier", "Xterra"]},
      'Land Rover': {'named_tags.Model': ["Range Rover", "Land Rover Sport"]},
      'Pontiac': {'named_tags.Model': ["Grand Prix", "Bonneville"]},
      'Saturn': {'named_tags.Model': ["Redline"]},
      'Toyota': {'named_tags.Model': ["Tacoma"]},
      'Jaguar': {'named_tags.Model': ["F-Type", "XFR", "XFR-S", "XJ", "XJR", "XKR", "XKR-S"]},
      'Oldsmobile': {'named_tags.Model': ["LSS"]}
    },
    'product_type' : {
      'Muffler Delete': {
        'tags': ['Aluminized Mandrel Bends', 'Aluminized Pipe', 'Dodge', 'Exhaust Kits', 'Exhaust Products', 'Mandrel Bends', 'Muffler Deletes'],
        'named_tags.Model': ['Camaro'],
        'named_tags.OD': ['2.75"'],
        'named_tags.Material': ['Aluminum']
      },
      'Stainless Steel Mandrel Bends' : {
        'tags': ['1 5/8 Tubing', '1-5/8"', 'Exhaust', 'Exhaust Products', 'Mandrel Bends', 'Mandrel Bends_Stainless Steel', 'Stainless Steel', 'Stainless Steel Mandrel Bends'],
        'named_tags.Degree': ['180','45'],
        'named_tags.OD': ['1 5/8"','1.625"','1.75"'],
        'named_tags.Material': ['Stainless Steel']
      },
      'Stainless Steel' : {
        'tags': ['Exhaust'],
        'named_tags.OD': ['1 5/8"'],
        'named_tags.Material': ['Stainless Steel']
      },
      'Aluminized Mandrel Bends' : {
        'tags': ['3" Aluminized', '3" Tubing', 'Aluminized Mandrel Bends', 'Exhaust Products', 'Mandrel Bends', 'Mandrel Bends_Aluminized Steel'],
        'named_tags.Degree': ['90'],
        'named_tags.OD': ['3"'],
        'named_tags.Material': ['Aluminum']
      },
      'Coupler' : {
        'tags': ['Couplers', 'Exhaust Products'],
        'named_tags.ID': ['2.5"','3"'],
        'named_tags.Material': ['Aluminum'],
      },
      'Couplers' : {
        'tags': ['Couplers', 'Exhaust Products'],
        'named_tags.ID': ['3"'],
        'named_tags.Material': ['Stainless Steel']
      },
    },
    'named_tags.Year' : {
      '1987':{ 'named_tags.Engine':['4.3','5.0','5.7','7.4'] },
      '1988':{ 'named_tags.Engine':['4.3','5.0','5.7','7.4'] },
      '1989':{ 'named_tags.Engine':['4.3','5.0','5.7','7.4'] },
      '1990':{ 'named_tags.Engine':['4.3','5.0','5.7','7.4'] },
      '1991':{ 'named_tags.Engine':['4.3','5.0','5.7','7.4','3.8'] },
      '1992':{ 'named_tags.Engine':['4.3','5.0','5.7','7.4','3.8'] },
      '1993':{ 'named_tags.Engine':['4.3','5.0','5.7','7.4','3.8'] },
      '1994':{ 'named_tags.Engine':['4.3','5.0','5.7','7.4','3.8'] },
      '1995':{ 'named_tags.Engine':['4.3','5.0','5.7','7.4','3.8'] },
      '1996':{ 'named_tags.Engine':['3.8'] },
      '1997':{ 'named_tags.Engine':['3.8'] },
      '1998':{ 'named_tags.Engine':['3.8'] },
      '1999':{ 'named_tags.Engine':['4.3','4.8','5.3','6.0','3.8','5.4'] },
      '2000':{ 'named_tags.Engine':['4.3','4.8','5.3','6.0','3.8','5.4'] },
      '2001':{ 'named_tags.Engine':['4.3','4.8','5.3','6.0','3.8','5.4','3.3'] },
      '2002':{ 'named_tags.Engine':['4.3','4.8','5.3','6.0','3.8','5.4','3.3'] },
      '2003':{ 'named_tags.Engine':['3.5','4.3','4.8','5.3','6.0','3.8','5.4','4.6','3.3'] },
      '2004':{ 'named_tags.Engine':['3.5','4.3','4.8','5.3','6.0','3.8','5.4','4.6','3.3'] },
      '2005':{ 'named_tags.Engine':['5.7','6.1','3.5','4.3','4.8', '5.3','6.0','3.8','2.0'] },
      '2006':{ 'named_tags.Engine':['5.7','6.1','3.5','4.3','4.8', '5.3','6.0','2.0'] },
      '2007':{ 'named_tags.Engine':['5.7','6.1','3.5','4.3','4.8', '5.3','6.0','2.0'] },
      '2008':{ 'named_tags.Engine':['5.7','6.1','3.5','6.0'] },
      '2009':{ 'named_tags.Engine':['5.7','6.1','3.5','6.0'] },
      '2010':{ 'named_tags.Engine':['5.7','6.1','5.0','6.0'] },
      '2011':{ 'named_tags.Engine':['5.7','6.4','3.6','5.0','6.0'] },
      '2012':{ 'named_tags.Engine':['5.7','6.4','3.6','5.0','6.0'] },
      '2013':{ 'named_tags.Engine':['5.7','6.4','3.6','5.0','6.0'] },
      '2014':{ 'named_tags.Engine':['5.7','6.4','3.6','5.0','6.0'] },
      '2015':{ 'named_tags.Engine':['5.7','6.4','6.2','3.6','5.0','6.0'] },
      '2016':{ 'named_tags.Engine':['5.7','6.4','6.2','3.6','5.0','6.0'] },
      '2017':{ 'named_tags.Engine':['5.7','6.4','6.2','3.6','6.0'] },
      '2018':{ 'named_tags.Engine':['5.7','6.4','6.2','3.6','6.0'] },
      '2019':{ 'named_tags.Engine':['5.7','6.4','6.2','3.6','6.0'] },
      '2020':{ 'named_tags.Engine':['5.7','6.4','6.2','3.6','6.0'] },
      '2021':{ 'named_tags.Engine':['5.7','6.4','6.2','3.6','6.0'] },
      '2022':{ 'named_tags.Engine':['5.7','6.4','6.2','3.6','6.0'] }
    }
  };

  var TYPES_TO_WIDGET = {
    slider: { name: 'rangeSlider', useDefault: true, widget: rangeSlider },
    menu: { name: 'menu', params: { limit: 140 }, widget: menu },
    conjunctive: {
      name: 'refinementList',
      params: { operator: 'and', limit: 140 },
      widget: refinementList,
    },
    disjunctive: {
      name: 'refinementList',
      params: { operator: 'or', limit: 140 },
      widget: refinementList,
    },
  };

  var sortByRefined = function sortByRefined(sortFunction) {
    return function(a, b) {
      if (a.refined !== b.refined) {
        if (a.refined) {
          return -1;
        }
        if (b.refined) {
          return 1;
        }
      }
      return sortFunction(a, b);
    };
  };

  /*
   * Sorting functions : Allows to chose in which order you want to display the facets
   * Algolia will always send you back the most relevant values for each facet (the ones
   * with the highest count). These sorting functions won't change which results come back
   * but how they are displayed. To retrieve more results, change the maxValuesPerFacet
   * parameter in your Algolia Dashboard.
   * The default sort function is refined > count > name.
   */
  algolia.facetSortFunctions = {
    price_range: sortByRefined(function sortRanges(a, b) {
      if (a.name.length === b.name.length) {
        return a.name.localeCompare(b.name);
      }
      return a.name.length - b.name.length;
    }),
    'named_tags.Year': function sortRanges(a, b) {
      return a.name.localeCompare(b.name) * -1;
    },
    'product_type': function sortRanges(a, b) {
      return a.name.localeCompare(b.name) ;
    }
  };

  /*
   * Display functions
   * When the object sent back for a facet item doesn't match how you would want it to look
   * like, use a function to reformat it how you want.
   */
  algolia.facetDisplayFunctions = {
    price_range: function displayRange(value) {
      var values = value.split(':');

      return values
        .map(function(e) {
          return algolia.formatMoney(Number(e) * 100).replace(/\.\d+/, '');
        })
        .join(' - ');
    },
  };

  algolia.facetCssClasses = {
    root: 'ais-facet',
    header: 'ais-facet--header',
    body: 'ais-facet--body',
    item: 'ais-facet--item',
    label: 'ais-facet--label',
    checkbox: 'ais-facet--checkbox',
    active: 'ais-facet--active',
    count: 'ais-facet--count',
  };

  var enabledFacets = algolia.config.facets.filter(function(facet) {
    return facet.enabled || parseInt(facet.enabled, 10);
  });
  algolia.facets = enabledFacets.map(function(facet) {
    return algolia.assign({}, facet, {
      escapedName: encodeURIComponent(facet.name),
    });
  });
  algolia.shownFacets = algolia.facets.filter(function(facet) {
    return facet.type !== 'hidden';
  });
  algolia.hiddenFacets = algolia.config.facets.filter(function(facet) {
    return facet.type === 'hidden';
  });

  var facetToWidget = function(facet) {

    var widget = TYPES_TO_WIDGET[facet.type];
    var params = algolia.assign({}, widget.params);

    params.container =
      "[class~='ais-facet-" + facet.escapedName + "-container']";
    params.attribute = facet.name;
    params.templates = {};
    params.cssClasses = algolia.facetCssClasses;

    /**
     * Providing a custom "Show more" template to confirm to the custom
     * Hogan delimiter
     */
    params.templates.showMoreText = algolia.getTemplate(
      'instant_search_facet_show_more'
    );

    if (facet.searchable) {
      params.searchable = true;
      params.searchablePlaceholder = 'Search for ' + facet.title;
      params.templates.searchableNoResults = '<div> No matching for ' + facet.title + '</div>';
    }

    params.templates.header = function() {
      return facet.title;
    };
    if(facet.name == "meta.accentuate.color" || facet.name == "meta.accentuate.finish_color") {
      params.templates.item = algolia.getTemplate('instant_search_facet_color_item');
    } else if (!widget.useDefault) {
      params.templates.item = algolia.getTemplate('instant_search_facet_item');
    }

    if (algolia.facetSortFunctions[facet.name]) {
      params.sortBy = algolia.facetSortFunctions[facet.name];
    }

    var displayFunction = algolia.facetDisplayFunctions[facet.name];
    params.transformItems = function(items) {
      //Chrysler
      var facetsRefinements = algolia.instantsearch.search.helper.state.facetsRefinements;

      //console.log("facet",facet)


      var names = [];
      var root_facetes = Object.keys(facetes_relation)
      root_facetes.forEach(function (item) {
        if(facetsRefinements[item] != undefined){
          if(facetsRefinements[item].length > 0) { // if user select some filter
            for(var i = 0;i < facetsRefinements[item].length ;i++) {
              var value = facetsRefinements[item][i]; // get value of selected filter
              if(facetes_relation[item].hasOwnProperty(value) // if wee have filter for this selected value
                && facetes_relation[item][value].hasOwnProperty(facet.name) ) { // and have filterers for current facet
                names = names.concat(facetes_relation[item][value][facet.name])
              }
            }
          }
        }
      });

      if(names.length > 0) {
        items = items.filter(function(item) {
          return names.includes(item.value)
        });
      } else {

        // if(facetsRefinements['product_type'].length == 0
        //     && facet.name == 'named_tags.OD') {
        //   console.log(facetsRefinements['product_type'].length)
        //   console.log('product_type selected',facet.name,items)
        //   items = items.filter(function(item) {
        //     return false
        //   });
        // }
      }
      // test
      return items.map(function(item) {
        var transformedItem = algolia.assign({}, item);
        transformedItem.type = {};
        transformedItem.type[facet.type] = true;
        transformedItem.label = displayFunction
          ? displayFunction(item.value)
          : item.value;
        
       // console.log("transformedItem",transformedItem,facet)
        return transformedItem;
      });
    };

    return {
      name: widget.name,
      params: params,
      widget: widget.widget,
    };
  };

  // try to fetch facets for current collection or fallback to collections default
  var collection_facets =
    algolia.current_collection_id &&
    algolia.config.collection_facets &&
    algolia.config.collection_facets[algolia.current_collection_id]
      ? algolia.config.collection_facets[algolia.current_collection_id]
      : algolia.config.collection_facets &&
        algolia.config.collection_facets.default;

  if (collection_facets) {
    var enabledCollectionFacets = collection_facets.filter(function(facet) {
      return facet.enabled || parseInt(facet.enabled, 10);
    });

    algolia.collectionFacets = enabledCollectionFacets.map(function(facet) {
      return algolia.assign({}, facet, {
        escapedName: encodeURIComponent(facet.name),
      });
    });
    algolia.collectionShownFacets = algolia.collectionFacets.filter(function(
      facet
    ) {
      return facet.type !== 'hidden';
    });
    algolia.collectionHiddenFacets = collection_facets.filter(function(facet) {
      return facet.type === 'hidden';
    });
    algolia.collectionFacetsWidgets = algolia.collectionShownFacets.map(
      facetToWidget
    );
  }
  algolia.facetsWidgets = algolia.shownFacets.map(facetToWidget);
})(window.algoliaShopify);
